import React, {useState, useEffect} from 'react';
import './LastModified_History.scss'
import {default as _} from "../../../helpers/Translate"
import {connect} from "react-redux";
import Modal from "../../../shared/component/Modal/Modal";
import T from "../../../shared/component/t/T";
import snippets from "../../../helpers/snippets";
import {getStyle, getSymbol} from "../../../core/constants/ReportState";
import User from "../../../core/api/User2/Users";
import Popover from "../../../shared/component/Popover/Popover";
import StringDiff from "../../../shared/component/DiffComponents/StringDiffs";


const LastModified_History = (props) => {
	const [popShow, setPopShow] = useState(props.show)
	const [modalShow, setModalShow] = useState(false)
	
	const [report] = useState(props.report)
	const [history, setHistory] = useState([])
	const [item, setItem] = useState(props?.item)
	
	useEffect(() => {
		setPopShow(props.show)
	}, [props.show])
	
	useEffect(() => {
		if (!snippets.isObjectEmpty(report?.history)) {
			setHistory(report?.history?.filter(item => item.changes && item.changes.hasOwnProperty('findings')))
		}
	}, [report])
	
	const closePopover = (event, ignore) => {
		if (ignore) return
		setPopShow(false)
		props?.onClose()
	}
	
	const closeModal = () => {
		setModalShow(false)
		setItem({})
	}
	
	const popoverItemClicked = (item) => {
		let exist = history.some(it => JSON.stringify(it) === JSON.stringify(item));
		if (exist && modalShow) {
			setItem(item)
		} else if (exist) {
			closePopover(null, false)
			setModalShow(true)
			setItem(item)
		} else {
			console.warn('item is not in list')
		}
	}
	
	const getReportHistory = () => {
		if (report?.history) {
			return report?.history?.map((item, index) => <>
				  <div className={`report_history_brief_k234jd23fhg ${history.includes(item) ? 'clickable' : 'not_clickable'}`} onClick={() => popoverItemClicked(item)}>
					  <span className={'report_history_brief__username'}> {userInfo(item?.user)} </span>
					  <span
						className={'report_history_brief__changes_k2j5k4jg6'}> {reportStatusArrow(item.changes?.status, index)} </span>
					  <span
						className={'report_history_brief__time_m4l4300f'}> {_.datetime(item.create_time)} - {_.datetime2time(item.create_time)} </span>
				  </div>
			  </>
			)
		}
	}
	
	const reportStatusArrow = (sta, ind) => {
		let rightOrLeft = props.direction === "rtl" ? "left" : "right"
		let arrow = <i className={`fa fa-light fa-arrow-${rightOrLeft}-long fa-xl px-1`}/>
		if (ind === 0) {
			return <span> {circularState(0)} {arrow} {circularState(sta)} </span>
		} else {
			let lastChange = report?.history[ind - 1]?.changes
			if (lastChange?.status === sta) {
				return <span> {circularState(sta)} </span>
			} else {
				return <span> {circularState(lastChange?.status)} {arrow} {circularState(sta)} </span>
			}
		}
	}
	
	const circularState = (state) => {
		return <span className={`circular_state`}
		             style={{...getStyle(state)}}
		>
            {getSymbol(state)?.toUpperCase()}
        </span>
	}
	
	const userInfo = (user) => {
		return getRole(user?.roles, user?.display_name)
	}
	
	const getRole = (role, display_name) => {
		if (User.isAdminByRole(role)) {
			return `${_.init('admin', props.language)} (${display_name})`
		} else if (User.isStaffByRole(role)) {
			return `${_.init('staff', props.language)} (${display_name})`
		}else if (User.isAssistantByRole(role)) {
			return `${_.init('assistant', props.language)} (${display_name})`
		} else if (User.isResidentByRole(role)) {
			return `${_.init('resident', props.language)} (${display_name})`
		} else if (User.isTypistByRole(role)) {
			return `${_.init('typist', props.language)} (${display_name})`
		} else {
			return display_name
		}
	}
	
	const historyPopover = () => {
		return <>
			<Popover show={popShow}
			         className={"report_history_popover"}
			         title={"changes_history"}
			         closePopover={closePopover}
					 style={{zIndex: 3010}}
			>
				{getReportHistory()}
			</Popover>
		</>
	}
	
	const modalItemClick = (item) => {
		popoverItemClicked(item)
	}
	
	const fullDetailsHistoryModal = () => {
		let beforeInd = history.findIndex(it => JSON.stringify(it) === JSON.stringify(item));
		let before = {findings: '', impression: '', description_name: ''}
		if (item && beforeInd >= 1 && history[beforeInd - 1]) {
			before = {...before, ...history[beforeInd - 1]?.changes}
		} else if (beforeInd === 0) {
		} else {
			return console.warn("why there is no item?")
		}
		let changesKeySorted = Object.keys(item?.changes)?.filter(k => ['findings', 'impression', 'description_name'].includes(k)).sort();


		const footer = <div className={'imodal__action'}>
			<div className={'imodal__btn imodal__btn--secondary'}
			     onClick={closeModal}><T token={'close'}/>
			</div>
		</div>
		
		return (
		  <Modal show={modalShow}
		         className={'report_history_modal'}
		         closeModal={closeModal}
		         title='report_changes'
		         closeable={true}
		         footer={footer}
		  >
			  
			  <div className={'imodal report_history'}>
				  <div className={'imodal__body report_history_body'}>
					  <div className={'report_history_RIGHT_SIDE'}>
						  <div className={'report_history_RIGHT_SIDE__title'}><T token={'changes_history'}/></div>
						  <div className={'report_history_RIGHT_SIDE__list'}>
							  {
								  history?.map((hi, index) => {
									  return <span
										className={`report_history_RIGHT_SIDE__list_item report_history_brief__items_k494mv94mv ${hi === item ? 'selected' : ''}`}
										onClick={() => modalItemClick(hi)}
									  >
                                    <span className={'report_history_brief__changes_k2j5k4jg6'}>
                                        {reportStatusArrow(hi.changes?.status, index)}
                                    </span>
                                    <span className={'report_history_brief__time_m4l4300f'}>
                                        {_.datetime(hi.create_time)} - {_.datetime2time(hi.create_time)}
                                    </span>
                                </span>
								  })
							  }
						  </div>
					  </div>
					  
					  <div className={'report_history_LEFT_SIDE'}>
						  <div className={'report_history_LEFT_SIDE__with'}>
							  <T token={'by'}/> :
							  <span className={'px-1'}>
                            {userInfo(item?.user)}
                        </span>
						  </div>
						  <div className={'report_history_LEFT_SIDE__changes'}>
							  {
								  changesKeySorted.map(key => {
									  return <div className={'report_history_LEFT_SIDE__changes_item'}>
                                    <span className={'report_history_LEFT_SIDE__changes_title'}>
	                                    <T token={`${key}_changes`}/>:
									</span>
                                    <hr/>
                                    <span className={'report_history_LEFT_SIDE__changes_change'}>
	                                    {/*TODO: show diffs as markdown*/}
                                        {/*<Viewer height='95%'*/}
	                                    {/*        width='95%'*/}
	                                    {/*        initialValue={diffs(before[key], item?.changes[key])}*/}
	                                    {/*/>*/}
	                                    <StringDiff before={before[key]} after={item.changes[key]}
	                                                direction={report?.direction}/>
                                    </span>
                                </div>
								  })
							  }
						  </div>
						  <div className={'report_history_LEFT_SIDE__description'}>
                        <span className={'report_history_LEFT_SIDE__description_title'}>
                            <T token={'guidance'}/> :
                        </span>
							  <span className={'report_history_LEFT_SIDE__description_removed'}>
                            <span className={'report_history_LEFT_SIDE__description_removed_icon'}> </span>
                            <T token={'removed_items'}/>
                        </span>
							  <span className={'report_history_LEFT_SIDE__description_added'}>
                            <span className={'report_history_LEFT_SIDE__description_added_icon'}> </span>
                            <T token={'added_items'}/>
                        </span>
						  </div>
					  </div>
				  </div>
				  
			  </div>
		  </Modal>
		)
	}
	
	
	return <>
		{props.mode === "popover" ? historyPopover() : null}
		{modalShow && fullDetailsHistoryModal()}
	</>
};

const mapStateToProps = state => {
	const language = state.LangReducer.language;
	const direction = state.LangReducer.direction;
	return {language, direction};
};

export default connect(mapStateToProps)(LastModified_History);